export const ADD_BACKUP_EMAIL = 'add-your-backup-email';
export const BACKUP_EMAIL_CONFIRMED = 'add-backup-email-success';
